import React from 'react'


function Header() {
    return (
        <h1>Hello</h1>
    )
}

export default Header;